import React from "react";

// WhatsApp
const WhatsAppPage = React.lazy(() => import("../../WhatsApp/WhatsAppPage"));
const WhatsApp = React.lazy(() => import("../../WhatsApp/WhatsApp"));
const WhatsappSendMessage = React.lazy(() => import("../../WhatsApp/WhatsappSendMessage"));
const WhatsappTemplates = React.lazy(() => import("../../WhatsApp/WhatsappTemplates"));
const WaAddTemplates = React.lazy(() => import("../../WhatsApp/WaAddTemplates"));
const AccountSettings = React.lazy(() => import("../../Accounts/AccountSettings/AccountSettings"));

// Message Automation
const MessageAutomation = React.lazy(() => import("../../MessageAutomation/MessageAutomation"));

// Deletion Audit Logs
const DeletionAuditLogsTable = React.lazy(
  () => import("../../Settings/DeletionAuditLogs/DeletionAuditLogsTable"),
);

export const settingsRoutes = [
  // WhatsApp
  {
    path: "/settings/whatsapp/instances",
    Component: WhatsAppPage,
    rolename: "WhatsApp_Connect",
  },
  {
    path: "/settings/whatsapp/instances/add",
    Component: WhatsApp,
    rolename: "Settings_WhatsApp",
  },
  {
    path: "/settings/whatsapp/wa-send-message",
    Component: WhatsappSendMessage,
    rolename: "WhatsApp_Send Message",
  },
  {
    path: "/settings/whatsapp/wa-templates",
    Component: WhatsappTemplates,
    rolename: "WhatsApp_History",
  },
  {
    path: "/settings/whatsapp/wa-templates/add",
    Component: WaAddTemplates,
    rolename: "WhatsApp_History",
  },

  // Message Automation
  {
    path: "/settings/automation",
    Component: MessageAutomation,
    rolename: "ERP-Settings_Automation",
  },
  {
    path: "/settings/account-settings",
    Component: AccountSettings,
    rolename: "ERP-Profile_Business Profile",
  },
  // Deletion Audit Logs
  {
    path: "/settings/deletion-logs",
    Component: DeletionAuditLogsTable,
    rolename: "WhatsApp_Connect",
  },
];
